// ============================================================
// ClickBank Hoplink Configuration
// ------------------------------------------------------------
// Replace the value of HOPLINK below with your real ClickBank
// hoplink URL when ready. All CTA buttons on the site read
// this single constant, so one change updates the entire site.
// ============================================================

export const HOPLINK = "https://8e897k1k5lhses3-sel6e3uc3d.hop.clickbank.net";

// Whether the link should open in a new tab (recommended for affiliate offers).
export const HOPLINK_TARGET = "_blank";
export const HOPLINK_REL = "sponsored nofollow noopener";
